import CryptoJS from "crypto-js";
export const setCookie = (
  msisdn: any,
  token: any,
  packageDetail?: any,
  parameterDetail?: any,
) => {
  clearAllCookies();
  let data = {
    msisdn: msisdn,
    token: token,
    packageDetail: packageDetail,
    parameterDetail: parameterDetail,
  };
  const maxAge = 30 * 24 * 60 * 60;
  document.cookie = `data=${encodeURIComponent(
    JSON.stringify(data),
  )}; SameSite=Strict; path=/; max-age=${maxAge}`;
};

export const getCookie = (name: any) => {
  try {
    const cookies = document.cookie
      .split(";")
      .reduce((acc: Record<string, string>, cookie) => {
        const [key, value] = cookie.split("=");
        console.log("key", key);
        console.log("value", value);
        acc[key.trim()] = decodeURIComponent(value);
        return acc;
      }, {});
    console.log("cookies[name]", JSON.parse(cookies[name]));
    return cookies[name] ? JSON.parse(cookies[name]) : null;
  } catch (e) {
    console.log("error", e);
    return null;
  }
};
export const clearAllCookies = () => {
  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
  });
};

export const logout = () => {
  clearAllCookies();
  let url = window.location.origin;
  url = `${url}/`;
  window.location.replace(url);
};

export const getChargesText = (packageId: number): string => {
  switch (packageId) {
    case 1:
      return "*Note: Only for Rs.5+Tax/Day (Prepaid) & Rs.70+Tax/Month (Postpaid)";
    case 2:
      return "*Note: Only for Rs. 14.43+ Tax/Week (Prepaid) & Rs. 70+Tax/Month (Postpaid)";
    default:
      return "*Note: Only for Rs.5+Tax/Day (Prepaid) & Rs.70+Tax/Month (Postpaid)";
  }
};
export const sha256Hash = (value: string) => {
  return CryptoJS.SHA256(value.trim().toLowerCase()).toString();
};
